import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Dialog, DialogFooter, DialogHeader, Inline, StickyBottom, Text } from '@ui-lib';
import { vars } from '@ui-lib/css';

type UnlinkConfirmationDialogProps = {
  title: string;
  onCancel: () => void;
  onSave: () => void;
};

export const UnlinkConfirmationDialog = ({
  title,
  onCancel,
  onSave,
}: UnlinkConfirmationDialogProps): JSX.Element => (
  <Dialog>
    <DialogHeader title={title} />

    <Box padding="medium" flexDirection="column" style={{ maxHeight: '600px', overflowY: 'auto' }}>
      <Box paddingBottom="small">
        <Inline alignY="center" gap="xsmall">
          <FontAwesomeIcon color={vars.color.foreground.caution} icon={faQuestionCircle} />
          <Text tone="caution" weight="demibold">
            Are you sure?
          </Text>
        </Inline>
      </Box>

      <Text>
        {title} is a linked field. By clicking <b>Save and Unlink</b>, this field will be unlinked and your
        changes will be saved.
      </Text>
    </Box>

    <StickyBottom>
      <DialogFooter>
        <Box display="flex" justifyContent="flexEnd">
          <Button type="button" variant="outline" onClick={onCancel}>
            Cancel
          </Button>

          <Box marginLeft="small">
            <Button onClick={onSave} variant="solid">
              Save and Unlink
            </Button>
          </Box>
        </Box>
      </DialogFooter>
    </StickyBottom>
  </Dialog>
);
